<div class="nav-item" [class.active]="isActive">
  <div class="button-container">
    @if (hasBadge) {
      <div class="notification-dot" role="status"></div>
    }
    <div class="icon-box">
      <ptl-icon [icon]="icon" [size]="size"></ptl-icon>
    </div>
  </div>
</div>
